import React from "react";
import { ReactComponent as EmptyNotificationsIcon } from "../../assets/icons/empty-notifications.svg";
import { EmptyState, EmptyTitle, EmptySubtitle } from "./styles";

type Props = {
  title?: string;
  subtitle?: string;
};

const EmptyNotifications = ({
  title = "You are all caught up",
  subtitle = "Every transaction and payout update has been read.",
}: Props) => {
  return (
    <EmptyState>
      <EmptyNotificationsIcon />
      <EmptyTitle>{title}</EmptyTitle>
      <EmptySubtitle>{subtitle}</EmptySubtitle>
    </EmptyState>
  );
};

export default EmptyNotifications;
